import { observer } from 'mobx-react-lite';
import { TradePlan } from '../../../../../classes/tradePlan/tradePlanTypes';
import { useWebsocketStore } from '../../../../../stores/websocketStore/websocketProvider';
import { TextButton } from '../../../../atomic/atomicComponentLibrary/buttons/textButton/TextButton';
import { BorderAndLabel } from '../../../../atomic/atomicComponentLibrary/utility/borderAndLabel/BorderAndLabel';
import { fontSizes } from '../../../../atomic/text/Text';
import { QuickTrade } from '../../tradingModule/components/quickTrade/QuickTrade';
import { useQuickTradeState } from '../../tradingModule/components/utils/useQuickTradeState';
import { QuickTradeFunctions } from './quickTradeFunctions/QuickTradeFunctions';
import style from './TradePlanHubControls.module.css';
type Props = {
  selectedTradePlanId: string;
};

export const TradePlanHubControls = observer(
  ({ selectedTradePlanId }: Props) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan: TradePlan = tradePlanStore.tradePlans[selectedTradePlanId];
    const quickTradeState = useQuickTradeState();
    return (
      <>
        <BorderAndLabel
          backgroundColor="black"
          margin="10px 0 10px 0"
          label="Manage"
          color="white"
          fontSize={fontSizes.body3}
        >
          <div className={style.buttonRow}>
            <TextButton
              minWidth="70px"
              backgroundColor="orange"
              size="medium"
              loading={false}
              fontColor="white"
              clickHandler={() => {}}
            >
              Pause
            </TextButton>
            <TextButton
              minWidth="70px"
              backgroundColor="blue"
              size="medium"
              loading={false}
              fontColor="white"
              clickHandler={() => {}}
            >
              Restart
            </TextButton>

            <TextButton
              minWidth="70px"
              backgroundColor="red"
              size="medium"
              loading={false}
              fontColor="white"
              clickHandler={() => {}}
            >
              Cancel
            </TextButton>
            <TextButton
              minWidth="70px"
              backgroundColor="purple"
              size="medium"
              loading={false}
              fontColor="white"
              clickHandler={() => {}}
            >
              Clear
            </TextButton>
          </div>
        </BorderAndLabel>
        {/* <QuickTrade
          selectedTradePlan={selectedTradePlanId}
          symbol={null}
          quickTradeState={quickTradeState}
          margin="5px 0 0 0"
        /> */}
      </>
    );
  }
);
/*
  * Armed/Deactivated TP Controls
    Cancel
    Enter Long
    Enter Short
    Pause
    Restart
    Clear(clears a deactivated TP)
    Clear All(clears all deactivated TP)

  * Entered TP Controls
    * Close
      100%[Flatten]
      75%
      50%
      25%
      Close Qty.
    * Open
      100%[Dbl Down]
      75%
      50%
      25%
      Open Qty.

     



*/
